import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getTeaserItems, site } from "@/config/site";

export function useHomeContainer() {
  const { t, i18n } = useTranslation();
  const teaserItems = useMemo(() => getTeaserItems(t), [t, i18n.language]);

  return {
    site,
    teaserItems,
  };
}
